import FunctionParameterInput, { generateFieldSchema } from './FunctionParameterInput';

export { generateFieldSchema };

export default FunctionParameterInput;
